/**
 * The socket-frame action lives in its own module so the WebSocket hook can
 * import it without dragging the API client (and therefore the whole store)
 * into its import graph. The slice handles it in extraReducers.
 */
import { createAction } from '@reduxjs/toolkit'

export const frameReceived = createAction('aiChat/frameReceived')
